import SentryHelper from "./_sentry-helper";

export default function(){
    SentryHelper.log(
        'Sentry JS logging test via admin control panel.',
        SentryHelper.getSentry().Severity.Info,
        'This is some context'
    );

    throw 'Sentry JS exception test via admin control panel.';
}